import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useConfiguration } from "../hooks/useConfiguration";

/** Staff, timing, and contacts edit the same coverage path as the previous step. */
export function EditingBanner() {
  const { policyDraft } = useConfiguration();
  const name = policyDraft.displayName.trim() || "Untitled";

  return (
    <Box
      sx={{
        bgcolor: "#f8fafc",
        border: "1px solid #e4e7ec",
        p: 1.5,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 700 }}>
        Currently editing: {name}
      </Typography>
    </Box>
  );
}
